
<template>
  <div class="archive_list">
    <el-container>
      <el-main class="main">
        <div class="header">
          <div>
            <h3>Andy's Portfolio Archive</h3>
          </div>
          <div>
            <el-button type="info" @click="logout">Logout</el-button>
          </div>
        </div>

        <div class="filter_panel">
          <el-row class="all_filter_type">
            <el-col :span="24" :md="4">
              <div class="label">Choose filter tag(s):</div>
            </el-col>
            <el-col :span="24" :md="20">
              <ul>
                <li
                  v-for="tagItem in allTagList"
                  :key="tagItem"
                  :class="'tag_' + tagItem"
                  @click="onClickTag(tagItem)"
                >
                  {{ tagItem }}
                </li>
              </ul>
            </el-col>
          </el-row>

          <el-row class="current_filter_type">
            <el-col :span="24" :md="4">
              <div class="label">Selected tag(s):</div>
            </el-col>
            <el-col :span="24" :md="20">
              <ul>
                <li
                  v-for="tagItem in selectedTags"
                  :key="tagItem"
                  :class="'tag_' + tagItem"
                >
                  {{ tagItem }}
                </li>
              </ul>
            </el-col>
          </el-row>

          <el-row class="clear_tag_row">
            <el-col :span="24" :md="4">
              <el-button type="info" @click="onClickClearSelectedTags"
                >Clear selected tags</el-button
              >
            </el-col>
          </el-row>
        </div>

        <div class="content">
          <div
            v-masonry
            transition-duration="0.3s"
            item-selector=".custom_card"
            gutter="8"
            column-width=".custom_card"
            horizontal-order="true"
          >
            <div
              v-masonry-tile
              class="item"
              v-for="item in displayProjectList"
              :key="item.id"
            >
              <el-card class="custom_card">
                <img :src="getListImgPath(item.id)" class="image preview_img" />

                <div class="preview_info">
                  <div class="desc" v-if="item.desc">{{ item.desc }}</div>
                  <div class="date" v-if="item.project_date">
                    {{ item.project_date }}
                  </div>
                  <div class="tech" v-if="item.tech">
                    <i>Tech stack:</i>
                    &nbsp;
                    {{ item.tech }}
                  </div>
                  <div class="link" v-if="item.link">
                    <a :href="item.link" target="_blank">{{ item.link }}</a>
                  </div>
                  <div class="tag" v-if="item.tag.length > 0">
                    <i>Tags:</i>
                    <ul>
                      <li
                        v-for="tagItem in item.tag"
                        :key="tagItem"
                        @click="onClickTag(tagItem)"
                      >
                        {{ tagItem }}
                      </li>
                    </ul>
                  </div>

                  <div class="bottom_btn clearfix">
                    <el-button
                      type="success"
                      class="button"
                      @click="onClickDetail(item)"
                      >More Detail</el-button
                    >
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </el-main>
    </el-container>

    <el-dialog
      :visible.sync="dialogVisible"
      :fullscreen="true"
      :before-close="onClickCloseGallery"
    >
      <div class="gallery_content">
        <div class="gallery_thumbnails">
          <ul>
            <li
              v-for="(imgItem, index) in galleryThumbList"
              :key="index"
              @click="onClickThumb(index)"
            >
              <img :src="imgItem" />
            </li>
          </ul>
        </div>

        <div class="main_img">
          <img class="img_pic" :src="getGalleryMainImgPath()" />
          <div class="left_arrow" @click="onClickGalleryLeft">
            <img src="/assets/left_arrow.png" />
          </div>
          <div class="right_arrow" @click="onClickGalleryRight()">
            <img src="/assets/left_arrow.png" />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="onClickCloseGallery">Close</el-button>
      </span>
    </el-dialog>

    <el-backtop :visibility-height="60">
      <i class="el-icon-caret-top" style="color: #67c23a"></i>
    </el-backtop>
  </div>
</template>

<script>
// @ is an alias to /src
import projectListData from "../constant/ProjectListData";

export default {
  name: "ArchiveList",
  data() {
    return {
      displayProjectList: [],
      dialogVisible: false,

      currentDetailItem: {},
      currentDetailImgCount: 1,
      selectedMainImg: 1,
      galleryThumbList: [],

      selectedTags: [],
    };
  },
  computed: {
    allTagList() {
      let tempList = [];
      projectListData.forEach((item) => {
        if (item.tag.length > 0) {
          item.tag.forEach((tagItem) => {
            if (tempList.includes(tagItem) == false) {
              tempList.push(tagItem);
            }
          });
        }
      });
      tempList = tempList.sort();
      return tempList;
    },
  },
  watch: {
    selectedTags: function (newVal) {
      const tempProjectList = [];
      const idList = [];

      if (newVal.length == 0) {
        this.displayProjectList = projectListData;
      } else {
        newVal.forEach((item) => {
          projectListData.forEach((projectItem) => {
            if (
              idList.indexOf(projectItem.id) == -1 &&
              projectItem.tag.indexOf(item) > -1
            ) {
              tempProjectList.push(projectItem);
              idList.push(projectItem.id);
            }
          });
        });
        this.displayProjectList = tempProjectList;
      }
    },
  },
  created() {
    this.displayProjectList = projectListData;
  },
  methods: {
    logout() {
      this.$store.dispatch("actionLogout");
      this.$router.push("/");
    },
    onClickTag(tagName) {
      if (!this.selectedTags.includes(tagName)) {
        this.selectedTags.push(tagName);
      }
    },
    onClickClearSelectedTags() {
      this.selectedTags = [];
    },
    getListImgPath(itemName) {
      return `/assets/project_img/${itemName}/preview.jpg`;
    },
    onClickDetail(details) {
      this.currentDetailItem = details;
      this.currentDetailImgCount = details.img_count;

      for (let i = 1; i <= details.img_count; i++) {
        this.galleryThumbList.push(
          `/assets/project_img/${this.currentDetailItem.id}/${i}.jpg`
        );
      }
      this.dialogVisible = true;
    },
    getGalleryMainImgPath() {
      return `/assets/project_img/${this.currentDetailItem.id}/${this.selectedMainImg}.jpg`;
    },
    onClickThumb(index) {
      this.selectedMainImg = index + 1;
    },
    onClickGalleryLeft() {
      if (this.selectedMainImg > 1) {
        this.selectedMainImg = this.selectedMainImg - 1;
      }
    },
    onClickGalleryRight() {
      if (this.selectedMainImg < this.currentDetailImgCount) {
        this.selectedMainImg = this.selectedMainImg + 1;
      }
    },
    onClickCloseGallery() {
      this.dialogVisible = false;
      this.currentDetailItem = {};
      this.selectedMainImg = 1;
      this.galleryThumbList = [];
    },
  },
};
</script>

<style scoped lang="scss">
.archive_list {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: left;
    margin-bottom: 0;
    h3 {
      color: #67c23a;
      font-size: 40px;
      margin: 0;
    }
  }

  .filter_panel {
    background-color: rgba(0, 0, 0, 0.08);
    box-shadow: inset 1px 1px 3px 0px rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    padding: 20px;
    border-top: 1px solid #afafaf;
    border-bottom: 1px solid #afafaf;
    margin: 20px 0 30px 0;

    .label {
      text-align: right;
      padding-right: 20px;
      font-size: 14px;
    }

    .all_filter_type {
      text-align: left;
      margin-bottom: 20px;

      ul {
        padding: 0;
        margin: 0;
        list-style-type: none;
        display: flex;
        flex-wrap: wrap;
      }

      li {
        border: 1px solid transparent;
        padding: 5px 8px;
        border-radius: 3px;
        margin-right: 8px;
        margin-bottom: 8px;
        background: #ca9359;
        color: #ffffff;
        cursor: pointer;

        &.tag_highlight {
          background-color: #d68000;
          text-transform: uppercase;
        }

        &:hover {
          background-color: #cea479;
        }
      }
    }

    .current_filter_type {
      ul {
        padding: 0;
        margin: 0;
        list-style-type: none;
        display: flex;
      }

      li {
        border: 1px solid transparent;
        padding: 5px 8px;
        border-radius: 3px;
        margin-right: 3px;
        background: #9e9e9e;
        color: #ffffff;
      }
    }

    .clear_tag_row {
      margin-top: 20px;
      text-align: right;
      button {
        font-size: 14px;
        margin-right: 20px;
      }
    }
  }

  .content {
    margin-top: 5px;
  }

  .custom_card {
    border-radius: 8px;
    width: calc(25% - 10px);
    margin-bottom: 8px;
    @media screen and (max-width: 768px) {
      width: calc(50% - 10px);
    }

    .preview_img {
      max-width: 100%;
      width: 100%;
    }

    .preview_info {
      background-color: rgba(0, 0, 0, 0.6);
      box-shadow: inset 2px 2px 3px 0px rgba(0, 0, 0, 0.7);
      padding: 12px;
      text-align: left;
      font-size: 14px;
      margin-top: -3px;
      color: #ffffff;
      word-break: break-word;
      > div {
        margin-bottom: 10px;
      }
      .date {
        margin-bottom: 25px;
      }
      a {
        color: #95a3ff;
      }
    }

    .tag {
      ul {
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        margin-top: 5px;
      }
      li {
        list-style-type: none;
        border: 1px solid transparent;
        padding: 5px 8px;
        border-radius: 3px;
        margin-right: 8px;
        margin-bottom: 5px;
        background: #ca9359;
        color: #ffffff;
        cursor: pointer;
        &:hover {
          background-color: #cea479;
        }
      }
    }

    div.bottom_btn {
      text-align: right;
      margin-top: 35px;
      margin-bottom: 0;
      button {
        padding-left: 25px;
        padding-right: 25px;
        font-size: 15px;
      }
    }
  }

  .gallery_content {
    .gallery_thumbnails {
      box-shadow: inset 1px 1px 3px 0px rgba(0, 0, 0, 0.4);
      padding: 6px 0 4px 0;
      ul {
        padding: 0;
        margin: 0;
        /* display: flex;
        justify-content: center;
        max-width: 100%; */
        overflow-x: auto;
      }
      li {
        float: left;
        border: 1px solid #cccccc;
        list-style-type: none;
        margin: 6px 2px;
        cursor: pointer;
        height: 80px;
      }
      img {
        max-height: 80px;
      }
    }

    .main_img {
      position: relative;
      margin-top: 20px;
      .img_pic {
        max-width: 80%;
        @media screen and (max-width: 768px) {
          max-width: 100%;
        }
      }
      .left_arrow,
      .right_arrow {
        position: fixed;
        top: 45%;
        z-index: 2;
        width: 60px;
        cursor: pointer;
        @media screen and (max-width: 768px) {
          width: 40px;
        }

        img {
          max-width: 100%;
        }
      }
      .left_arrow {
        left: 5px;
        transform: rotateZ(180deg);
      }
      .right_arrow {
        right: 10px;
      }
    }
  }
}
</style>

<style lang="scss">
.archive_list {
  .el-dialog__header {
    height: 50px;
  }
  .el-main {
    overflow: visible;
  }
  .el-icon-close {
    font-size: 30px;
    margin-top: -10px;
  }
  .el-dialog__body {
    position: relative;
    padding: 0;
    @media screen and (max-width: 768px) {
      padding: 30px 10px;
    }
  }
  .el-dialog__footer {
    text-align: center;
  }
  .el-card {
    background-color: transparent;
  }
  .el-card__body {
    padding: 0;
  }
  .el-card.is-always-shadow,
  .el-card.is-hover-shadow:focus,
  .el-card.is-hover-shadow:hover {
    box-shadow: none;
  }
}
</style>


